export function backgroundColourFormatter(color){

    // No background chosen in the CMS means white, so rows without a value still
    // pick up the .bg-white spacing rules (first/last row and matching neighbours).
    if(!color){
        return 'bg-white';
    }

    switch (color) {
        case "Grey":
            return 'bg-light-grey';
        case "Dark Blue":
            return 'bg-dark-blue';
        case "Gradient Dark":
            return 'bg-gradient-dark';
        case "Gradient Mid":
            return 'bg-gradient-mid';
        case "Gradient Light":
            return 'bg-gradient-light';
        case "Gradient Neutral":
            return 'bg-gradient-neutral';
        case "Gradient Extra Light":
            return 'bg-gradient-extra-light';
        default:
            return 'bg-white';
    }
}

export function headingAltText (text){
    return text.replace(/\*(.*?)\*/g, '<span class="alt">$1</span>');
};

export function headingAltTextInHtml(html){
    if (!html) return html;
    return html.replace(/<(h[1-6])(\s[^>]*)?>([\s\S]*?)<\/\1>/gi, (_match, tag, attrs, inner) => {
        const replaced = inner.replace(/\*(.*?)\*/g, '<span class="alt">$1</span>');
        return `<${tag}${attrs || ""}>${replaced}</${tag}>`;
    });
};